import config from './config';
import encodeHTMLEntities from './utils/encodeHTMLEntities';
var Success = /*@__PURE__*/ (function () {
    function Success(element, state) {
        var _this = this;
        this.getElement = function () {
            return _this.element;
        };
        this.render = function (data) {
            var state = _this.state.getState();
            // hide / show matching elements according to state
            if (state.archived) {
                jQuery(_this.getElement())
                    .find('[data-created]')
                    .hide();
                jQuery(_this.getElement())
                    .find('[data-archived]')
                    .show();
                jQuery(_this.getElement())
                    .find('[data-updated]')
                    .hide();
                jQuery(_this.getElement())
                    .find('[data-title]')
                    .html(config.appointman.msg.SUCCESS_TITLE_ARCHIVED);
                jQuery(_this.getElement())
                    .find('.next-steps')
                    .hide();
            }
            else if (state.apmID) {
                jQuery(_this.getElement())
                    .find('[data-created]')
                    .hide();
                jQuery(_this.getElement())
                    .find('[data-archived]')
                    .hide();
                jQuery(_this.getElement())
                    .find('[data-updated]')
                    .show();
                jQuery(_this.getElement())
                    .find('[data-title]')
                    .html(config.appointman.msg.SUCCESS_TITLE_UPDATED);
            }
            else {
                jQuery(_this.getElement())
                    .find('[data-created]')
                    .show();
                jQuery(_this.getElement())
                    .find('[data-archived]')
                    .hide();
                jQuery(_this.getElement())
                    .find('[data-updated]')
                    .hide();
                jQuery(_this.getElement())
                    .find('[data-title]')
                    .html(config.appointman.msg.SUCCESS_TITLE_CREATED);
            }
            if (!data) {
                return;
            }
            jQuery(_this.element)
                .find('[data-bookingNumber]')
                .html(encodeHTMLEntities(data.bookingno));
            // apmType
            var apmType = state.apmType;
            apmType = config.appointman.msg.CHOOSE_TYPE_API[apmType.toString() + "_LABEL"];
            jQuery(_this.getElement())
                .find('[data-apmtype]')
                .find('[data-value]')
                .html(apmType);
            // shop
            var shopName = state.shopInfo.name;
            var shopStreet = state.shopInfo.street;
            var shopCity = state.shopInfo.postalcode + " " + state.shopInfo.city;
            jQuery(_this.getElement())
                .find('[data-shop] [data-name]')
                .html(encodeHTMLEntities(shopName));
            jQuery(_this.getElement())
                .find('[data-shop] [data-street]')
                .html(encodeHTMLEntities(shopStreet));
            jQuery(_this.getElement())
                .find('[data-shop] [data-city]')
                .html(encodeHTMLEntities(shopCity));
            // appointment
            var timeslot = state.timeslot;
            var date = state.dateLabel;
            jQuery(_this.getElement())
                .find('[data-appointment] [data-timeslot]')
                .html(encodeHTMLEntities(timeslot));
            jQuery(_this.getElement())
                .find('[data-appointment] [data-date]')
                .html(encodeHTMLEntities(date));
            // contact
            var contactName = state.firstname + " " + state.lastname;
            var email = state.email;
            var phone = state.phone;
            var apmTopic = state.apmTopic;
            apmTopic = state
                .APPOINTMAN_TYPES[state.apmType]
                .topics[apmTopic];
            var text = state.text;
            jQuery(_this.getElement())
                .find('[data-contact] [data-name]')
                .html(encodeHTMLEntities(contactName));
            jQuery(_this.getElement())
                .find('[data-contact] [data-email]')
                .html(encodeHTMLEntities(email));
            jQuery(_this.getElement())
                .find('[data-contact] [data-phone]')
                .html(encodeHTMLEntities(phone));
            jQuery(_this.getElement())
                .find('[data-contact] [data-apmTopic]')
                .html(encodeHTMLEntities(apmTopic));
            if (text) {
                if (text.length > 0) {
                    jQuery(_this.getElement())
                        .find('[data-contact] [data-message]')
                        .html(encodeHTMLEntities(text));
                }
                else {
                    jQuery(_this.getElement())
                        .find('[data-contact] [data-messageContainer]')
                        .hide();
                }
            }
            else {
                jQuery(_this.getElement())
                    .find('[data-contact] [data-messageContainer]')
                    .hide();
            }
        };
        this.state = state;
        this.element = element;
    }
    Success.prototype.show = function (data) {
        var _this = this;
        jQuery(this.element)
            .addClass('shown');
        setTimeout(function () {
            jQuery(_this.element)
                .addClass('loaded');
        }, 200);
        this.render(data);
    };
    return Success;
}());
export default Success;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/Success.ts
// module id = null
// module chunks = 